import { render, staticRenderFns } from "./CarouselTeasers.vue?vue&type=template&id=77a926e0&"
import script from "./CarouselTeasers.vue?vue&type=script&lang=js&"
export * from "./CarouselTeasers.vue?vue&type=script&lang=js&"
import style0 from "./CarouselTeasers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports